module.exports = __webpack_public_path__ + "img/file-plus-green.1eca8573.svg";